import React from 'react';
import './StatusBarText.css';

/**
 * Display static text.
 * @param text
 * @param className
 * @returns {JSX.Element}
 * @constructor
 */
export const StatusBarText = ({ text, className }) => {
    return (
        <div className={`text-wrapper ${className ?? ''}`}>
            {text}
        </div>
    );
};
